import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { TranslateService } from './../../shared/translate/translate.service';
import { Router, ActivatedRoute } from "@angular/router";
import { SignupFormConfigService } from '../../signupform/models/signupfromconfig.service';
import { SignupFormConfigModel, SubscriptionForSignupForm } from '../../signupform/models/signupformconfig.model';
import { IAPIResponse, IKeyValueInterface, WeGoConfig, RoleLevel } from "../../shared/config";
import { AuthService } from "../../shared/models/auth.service";
import { Location } from '@angular/common';
import { SignupService } from "../models/signup.service";
import { SignupModel } from "../models/signup.model";
import { TermsConditionPopup } from "../../termsconditionpopup/models/terms-condition-popup.service";
import { PrivacyStatementPopup } from "../../privacypopup/models/privacy-popup.service";
import { DropdownModel } from '../../report/models/report-filter-cost-center.model';

@Component({
  selector: 'wego-signup',
  template: require('../views/signup.component.html'),
  providers: [SignupFormConfigService, SignupService, TermsConditionPopup, PrivacyStatementPopup],
  styles: [`
    .logo img
    {
      height: 100px;
      float: right;
    }

    .scroll-bar
    {
        overflow:auto;
        height: 200px;    
    }

    .signupFormTitle
    {
      font-size: 35px;
      text-align: center;
      position:absolute;
      color: #3c8dbc;
      left:0px;
      right:0px;
    }

    .signupFormFooter
    {
      font-size: 20px;
      text-align: center;
      position:absolute;
      color: #3c8dbc;
      left:0px;
      right:0px;
    }

    .nav-pills > li {
      margin: 0;
    }

    .nav-pills > li > a {
      border-top: 0;
      background-color: #d7d7d7;
    }
    .nav-pills > li > a:hover,
    .nav-pills > li > a:focus{
      border-top: 0;
      background-color: #ddd;
    }

    .input-group.telephone-group .input-group-addon {
      padding: 0px;
      border: 0px;
    }
    .country-select {
      width: 60px;
      border: 1px solid #d2d6de;
      padding: 3px;
    }
  `]
})
export class SignUpComponent implements OnInit, OnDestroy {
  isBodyContent: boolean;
  isPrivacyBodyContent: boolean;

  //termsAndConditionHashId: any;

  termsAndConditionList: any[];
  privacyHashId: any;
  signUpConfigModel: SignupFormConfigModel;
  model: SignupModel;
  sub: any;
  signupParam: string;
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  private module: string;
  private popupMsg: string;
  isLoading: boolean = false;
  languageLbl: string = 'en';
  roleLevel = RoleLevel;
  bodyHTMLText: string;
  privacyBodyHTMLText: string;
  countryList: DropdownModel[];
  personCountryList: DropdownModel[];

  @ViewChild('successPopup') public successPopup: any;
  @ViewChild("termsConditionModel") public termsConditionModel: any;
  @ViewChild("privayStatementModel") public privacyModel: any;


  constructor(
    private signupConfigService: SignupFormConfigService,
    private signupService: SignupService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private translate: TranslateService,
    private authService: AuthService,
    private locationService: Location,
    private termsConditionPopup: TermsConditionPopup,
    private privacyPopup: PrivacyStatementPopup) { }

  ngOnInit(): void {
    this.translate.setDetectedLang();
    this.signUpConfigModel = new SignupFormConfigModel();
    this.model = new SignupModel();
    this.module = this.translate.instant('LblSignup');
    this.GetTelephoneCountry();
    this.GerSignUpDetail();
    this.languageLbl =['en','nl','de','fr','pl','pt'].indexOf(this.translate.currentLang) >= 0 ? this.translate.currentLang : 'de';
    this.GetTermsAndConditionsBySignupFormParam(this.signupParam);
    this.GetPrivacyBySignUpFormParam(this.signupParam);
    this.GetPersonCountry();
  }

  public GetTelephoneCountry() {
    this.authService.GetTelephoneCountry()
      .subscribe(
        res => {
          this.countryList = res.data;
        },
        error => {
          this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetPersonCountry() {
    this.authService.GetPersonCountry()
      .subscribe(
        res => {
          this.personCountryList = res.data;
        },
        error => {
          this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GerSignUpDetail() {
    this.isLoading = true;
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.signupParam = params['id'] || 'NA'; //'_Bx9u3eZsUw$';
        this.signupConfigService.GetSignupFormDetails(this.signupParam)
          .subscribe(
            res => {
              this.signUpConfigModel = res.data;
              this.model.countryCode1 = this.signUpConfigModel.countryCode1;
              this.model.countryCode2 = this.signUpConfigModel.countryCode2;
              this.model.countryCodeHashId = this.signUpConfigModel.defaultCountryHashId;
              this.isLoading = false;
              console.log(this.signUpConfigModel);
            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
              this.isLoading = false;
            });
      });
  }

  onSubmit(forms: any) {
    this.SignUp();
  }

  public SignUp() {
    this.isLoading = true;
    this.model.signupParam = this.signupParam;
    this.model.acceptedTermsAndConditionsHashIdList = this.termsAndConditionList.filter(b => b.accepted).map(a => a.termsAndConditionsHashId);
    this.model.privacyHashId = this.privacyHashId;

    this.model.svgWiseSubscriptionList = this.signUpConfigModel.svgWiseSubscriptionList;
    let lang = this.translate.currentLang;
    this.signupService.SignUp(this.model, lang)
      .subscribe(
        res => {
          if (res.data) {
            this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]);
            this.ShowSuccessPopup();
          }
          else {
            if (typeof res.error != "string") {
              this.errorModel = res.error;
            } else {
              this.errorMessage = res.error;
            }
          }
          this.isLoading = false;
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  public OnSubscriptionCheck(selectedSubscriptionHashId: string, svgHashId: string) {
    var svgWiseSubscription = this.signUpConfigModel.svgWiseSubscriptionList.filter((b: any) => b.svgHashId == svgHashId)[0].subscriptiopnListForSignupForm.filter((n: any) => n.organizationSubscriptionHashId != selectedSubscriptionHashId);
    var selectedsvgWiseSubscription = this.signUpConfigModel.svgWiseSubscriptionList.filter((b: any) => b.svgHashId == svgHashId)[0].subscriptiopnListForSignupForm.filter((n: any) => n.organizationSubscriptionHashId == selectedSubscriptionHashId);
    selectedsvgWiseSubscription[0].isChecked = true;

    for (let objSubscription of svgWiseSubscription) {
      objSubscription.isChecked = false;
    }
  }

  public GetSubscriptionChecked(SubscriptionHashId: string, svgHashId: string): boolean {
    if (this.signUpConfigModel && this.signUpConfigModel.svgWiseSubscriptionList) {
      var selectedsvgWiseSubscription = this.signUpConfigModel.svgWiseSubscriptionList.filter((b: any) => b.svgHashId == svgHashId)[0].subscriptiopnListForSignupForm.filter((n: any) => n.sharedVehicleGroupSubscriptionHashId == SubscriptionHashId);

      if (selectedsvgWiseSubscription && selectedsvgWiseSubscription.length > 0) {
        return selectedsvgWiseSubscription[0].isChecked;
      }
    }
    return false;
  }


  public ChangeCurrentLanguage(lang: string) {
    this.languageLbl = lang;
    localStorage.setItem("language", this.languageLbl);
    location.reload(true);
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    window.location.href = this.signUpConfigModel.successURL;
  }

  public GetImageURL(imagePath: string) {
    return WeGoConfig.API_SERVER_URL + imagePath;
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public showTnC(termsAndConditionsHashId: string) {
    let tnc = this.termsAndConditionList.filter(x => x.termsAndConditionsHashId == termsAndConditionsHashId)[0];
    if (tnc != null) {
      this.bodyHTMLText = tnc.content;
    }
    this.termsConditionModel.show(this.bodyHTMLText);
  }

  public showPrivacyStatement() {
    this.privacyModel.show(this.privacyBodyHTMLText);
  }

  public GetTermsAndConditionsBySignupFormParam(signupFormParam: string) {
    this.termsConditionPopup.GetTermsAndConditionsBySignupFormParam(signupFormParam)
      .subscribe(
        res => {
          if (res.data) {
            // this.bodyHTMLText = res.data.content;
            // if (res.data.content) {
            //   this.isBodyContent = true;
            // }
            // this.termsAndConditionHashId = res.data.termsAndConditionsHashId;
            this.termsAndConditionList = res.data;

          }
          else {
            this.errorMessage = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        });
  }

  public GetPrivacyBySignUpFormParam(signupFormParam: string) {
    this.privacyPopup.GetPrivacyBySignUpFormParam(signupFormParam)
      .subscribe(
        res => {
          if (res.data && res.data.content) {
            this.privacyBodyHTMLText = res.data.content;
            if (res.data.content) {
              this.isPrivacyBodyContent = true;
            }
            this.privacyHashId = res.data.termsAndConditionsHashId;
          }
          else {
            this.errorMessage = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        });
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/signup/components/signup.component.ts